import {Link} from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import {SidebarNav} from "./sidebar-nav";
import {NavUser} from "./nav-user";
import {Separator} from "@/components/ui/separator";
import Logo from "@/components/icons/logo";
import LogoFull from "@/components/icons/logo-full";

export function AppSidebar({...props}: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <Link
          to="/"
          className="flex h-8 items-center gap-2 px-2 group-data-[collapsible=icon]:justify-center"
        >
          <LogoFull className="h-4.5 w-auto group-data-[collapsible=icon]:hidden" />
          <Logo className="hidden h-4.5 w-auto group-data-[collapsible=icon]:block" />
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <SidebarNav />
      </SidebarContent>
      <SidebarFooter>
        <Separator className="mb-2" />
        <SidebarTrigger className="hidden self-end md:flex" />
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
